export enum ContextMenuVariant {
  PRIMARY = "primary",
  DESTRUCTIVE = "destructive",
}

export interface ContextMenuItems<TData> {
  id: string;
  label?: string;
  icon?: React.ElementType;
  className?: string;
  getDisabled?: (data: TData) => boolean;
  hidden?: boolean;
  getContent?: (data: TData) => React.ReactNode;
  tooltipContent?: string;
  onClick?: (data: TData) => void;
  isDivider?: boolean;
  variant?: ContextMenuVariant;
}

export interface ContextMenuProps<TData> {
  contextMenuItems?: ContextMenuItems<TData>[];
  data: TData;
  children: React.ReactNode;
  isDisabled?: boolean;
  shouldOpenContextMenuByLeftClick?: boolean;
  className?: string;
  modal?: boolean;
  usePortal?: boolean;
}
